<template>
    <v-dialog
        v-model="dialog"
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="text--main-yellow px-0"
                text
                v-bind="attrs"
                v-on="on"
                small
            >
                <span :class="{ 'text--main-yellow': btnText }">{{ btnText || $t('choose') }}</span>
                <v-img
                    v-if="paymentData.value && paymentData.value.id === 10"
                    class="mx-2"
                    contain
                    :src="liqPayIcon"
                    :max-width="liqPayImgWidth"
                    max-height="20"
                ></v-img>
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="justify-center py-4">
                {{ $t('paymentMethod') }}
            </v-card-title>
            <v-card-text class="justify-center text-center py-0">
                {{ `${$t('selectPaymentMethod')} ${sellerType}`}}<br>
                {{ orderSeller }}
            </v-card-text>
            <v-card-text class="justify-center py-0">
                <v-radio-group
                    column
                    v-model="paymentData.value"
                    :rules="rules.paymentWay"
                    class="text-center justify-center"
                >
                    <v-radio
                        v-for="way in paymentWays"
                        :key="way.id"
                        :value="way"
                        color="orange lighten-2"
                        class="px-0 pb-3 ma-0"
                    >
                        <template v-slot:label>
                            <div class="d-flex align-center">
                                <div class="d-inline-block text-body-2 text-md-body-1">{{ way.name }}</div>
                                <v-img
                                    v-if="way.id === 10"
                                    class="mx-2 d-inline-block"
                                    contain
                                    :src="liqPayIcon"
                                    :max-width="liqPayImgWidth"
                                    max-height="20"
                                ></v-img>
                            </div>
                        </template>
                    </v-radio>
                </v-radio-group>
                <template v-if="isSelectedCashlessLegalEntity">
                    <v-card-text class="px-0">
                        {{ $t('paymentWayEnterNameAndCode') }}
                    </v-card-text>
                    <v-text-field
                        v-model.trim="paymentData.lawData.full_name"
                        :label="$t('legalEntityName')"
                        :rules="rules.lawData"
                        color="orange lighten-2"
                    ></v-text-field>
                    <v-text-field
                        v-model.trim="paymentData.lawData.edprou"
                        :label="$t('codeEgrpou')"
                        :rules="[...rules.lawData, ...rules.edprou]"
                        color="orange lighten-2"
                    ></v-text-field>
                </template>
            </v-card-text>
            <v-card-actions class="justify-center pb-6">
                <v-btn
                    depressed
                    class="main--yellow white--text"
                    @click="dialog = false"
                >
                    {{ $t('save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import OrderBackup from '../../../../app-front/mixins/OrderBackup'
    import AppVariables from "../../../../app-front/mixins/AppVariables";

    export default {
        name: 'PaymentMethod',
        props: ['dialogData', 'policies', 'paymentWays'],
        mixins: [OrderBackup, AppVariables],
        data() {
            return {
                dialog: false,
                creditPolicy: null,
                picker: null,
                menu: false,
                valueCashlessLegalEntities: 'beznalichnyy-raschet-dlya-yur-lits',
                paymentData: {
                    value: null,
                    lawData: {
                        full_name: '',
                        edprou: '',
                    },
                },
                rules: {
                    paymentWay: [
                        v => !!v,
                    ],
                    lawData: [
                        v => this.isSelectedCashlessLegalEntity ? !!v : true
                    ],
                    edprou: [
                        v => v.length >= 8 && v.length <= 10 && Number.isInteger(+v),
                    ],
                },
            }
        },
        computed: {
            btnText() {
                if (!this.paymentData.value) {
                    return null;
                }

                return this.paymentWays.find(way => way.system_name === this.paymentData.value.system_name)?.name;
            },
            orderSeller() {
                return this.dialogData.companyName || `${ this.dialogData.lastName } ${ this.dialogData.firstName }`
            },
            sellerType() {
                return this.dialogData.companyName ? this.$t('forCompany').toLowerCase() : this.$t('forSeller').toLowerCase();
            },
            isSelectedCashlessLegalEntity() {
                return this.paymentData.value?.system_name === this.valueCashlessLegalEntities;
            },
            liqPayIcon() {
                return this.getCdnPath() + '/images/payment/liqpay.png';
            },
            liqPayImgWidth() {
                return window.innerWidth < 960 ? 60 : 70;
            }
        },
        methods: {
            setInitial() {
                if (!this.dialogData || !this.dialogData.id) return false;

                const backupSeller = this.backupGet().find(item => item.sellerID === this.dialogData.id);

                if (!backupSeller) return false;

                this.paymentData.value = backupSeller.paymentWay;
                this.creditPolicy = backupSeller.creditPolicy || null;
                this.paymentChange();
            },
            paymentChange() {
                this.$emit('payment-change', { value: this.paymentData, creditPolicy: this.creditPolicy });
            },
        },
        mounted() {
            this.setInitial();
        },
        watch: {
            paymentWays(value) {
                if (value && value.length) {
                    this.paymentData.value = value[0] || null;
                    this.paymentChange();
                }
            },
            dialog() {
                if (!this.dialog) {
                    this.paymentChange();
                }
            },
            'paymentData.value'(value) {
                if (value !== this.valueCashlessLegalEntities) {
                    this.paymentData.lawData = {
                        full_name: '',
                        edprou: '',
                    };
                }
            },
        },
    }
</script>

<style scoped>

</style>
